module.exports = " <div> <ly-login v-ref:login v-if=!isLogin></ly-login> <ly-home v-if=isLogin></ly-home> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
 ** module id = 45
 ** module chunks = 0
 **/